module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию..."
    }
  }) : (_vm.saving) ? _c('loading', {
    attrs: {
      "message": "Сохраняем информацию..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-10 col-lg-8"
  }, [_c('admin-card', [_c('admin-form-multi-select', {
    attrs: {
      "options": _vm.entityTypeOptions,
      "label-text": 'Тип сущности к которой относится',
      "error": _vm.$v.newDataItem.entityType.$error,
      "error-text": 'Тип обязательно должн быть указан'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.entityType.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.entityType),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "entityType", $$v)
      },
      expression: "newDataItem.entityType"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Название',
      "label-id": 'inputName',
      "input-require": true,
      "error": _vm.$v.newDataItem.name.$error,
      "error-text": 'Название обязательно должно быть указано, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.name.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.name),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "name", $$v)
      },
      expression: "newDataItem.name"
    }
  }), _vm._v(" "), _c('admin-form-multi-select', {
    attrs: {
      "options": _vm.typeOptions,
      "label-text": 'Тип поля',
      "error": _vm.$v.newDataItem.type.$error,
      "error-text": 'Тип обязательно должн быть указан'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.type.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.type),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "type", $$v)
      },
      expression: "newDataItem.type"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Код (разделяя точкой группы)',
      "label-id": 'inputCode',
      "input-require": true,
      "error": _vm.$v.newDataItem.code.$error,
      "error-text": 'Код обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.code.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.code),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "code", $$v)
      },
      expression: "newDataItem.code"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Идентификатор поля в AmoCrm',
      "label-id": 'inputAmoId',
      "input-require": false,
      "error": _vm.$v.newDataItem.amoId.$error,
      "error-text": 'Идентификатор должен состоять из цифр'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.amoId.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.amoId),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "amoId", $$v)
      },
      expression: "newDataItem.amoId"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Сортировка поля в карточке',
      "label-id": 'inputSort',
      "input-require": false,
      "error": _vm.$v.newDataItem.sort.$error,
      "error-text": 'Допустимо только число'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.sort),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "sort", $$v)
      },
      expression: "newDataItem.sort"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Обязательно для заполнения при редактировании'
    },
    model: {
      value: (_vm.newDataItem.required),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "required", $$v)
      },
      expression: "newDataItem.required"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Значение сможет видеть любой пользователь, который имеет доступ к просмотру сущности'
    },
    model: {
      value: (_vm.newDataItem.viewed),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "viewed", $$v)
      },
      expression: "newDataItem.viewed"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Значение сможет редактировать любой пользователь, который имеет доступ к редактированию сущности'
    },
    model: {
      value: (_vm.newDataItem.editable),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "editable", $$v)
      },
      expression: "newDataItem.editable"
    }
  }), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.newDataItem.id) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить кастомное поле")]], 2) : _vm._e()])], 2)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7245cb92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-7245cb92"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/CustomFields/CFEdit.vue
// module id = 1050
// module chunks = 1